import React from "react";
import { Result, Button, Typography, Space } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";

const { Title, Paragraph } = Typography;
interface NotFoundProps {
  message?: string;
  onBack?: () => void;
  className?: string;
}

const NotFound: React.FC<NotFoundProps> = ({ message = "抱歉，您访问的页面不存在或已被移除。", onBack, className }) => {
  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      window.location.href = "/";
    }
  };

  return (
    <div className={`component_NotFound_container ${className || ""}`}>
      <Result
        status="404"
        title={
          <Title
            level={2}
            style={{
              color: "#FF593E",
              marginBottom: 0,
              fontSize: 48,
              fontWeight: 600,
              lineHeight: 1.2,
            }}
          >
            404
          </Title>
        }
        subTitle={
          <Title
            level={3}
            style={{
              color: "#1a1a1a",
              marginBottom: 16,
              fontWeight: 600,
              lineHeight: 1.2,
            }}
          >
            页面未找到
          </Title>
        }
        extra={
          <Space
            direction="vertical"
            size="middle"
            style={{ width: "100%", maxWidth: 400 }}
          >
            <Paragraph
              style={{
                color: "#8c8c8c",
                fontSize: 16,
                lineHeight: 1.6,
                marginBottom: 0,
                textAlign: "center",
              }}
            >
              {message}
            </Paragraph>
            <Button
              type="primary"
              size="large"
              icon={<ArrowLeftOutlined />}
              onClick={handleBack}
              style={{
                backgroundColor: "#FF593E",
                borderColor: "#FF593E",
                width: "100%",
                height: 40,
                fontSize: 14,
                fontWeight: 500,
              }}
              onMouseEnter={(e) => {
                if (e.currentTarget) {
                  e.currentTarget.style.backgroundColor = "rgba(255, 89, 62, 0.8)";
                  e.currentTarget.style.borderColor = "rgba(255, 89, 62, 0.8)";
                }
              }}
              onMouseLeave={(e) => {
                if (e.currentTarget) {
                  e.currentTarget.style.backgroundColor = "#FF593E";
                  e.currentTarget.style.borderColor = "#FF593E";
                }
              }}
            >
              返回上一页
            </Button>
          </Space>
        }
      />
    </div>
  );
};

export default NotFound;
